import React, { useState } from "react";

function PaymentMethodModal(props) {
    const metodoDaModificare = props.metodoDaModificare;

    const [nome, setNome] = useState(metodoDaModificare ? metodoDaModificare.nome : "");
    const [conto, setConto] = useState(metodoDaModificare ? (metodoDaModificare.conto || "") : "");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!nome) {
            alert("Inserisci almeno il nome del metodo!");
            return;
        }
        props.onSave({
            id: metodoDaModificare ? metodoDaModificare.id : null,
            nome: nome,
            conto: conto.trim() === "" ? null : conto
        });
    };

    return (
        <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
                <h2>{metodoDaModificare ? "Modifica Metodo di Pagamento" : "Nuovo Metodo di Pagamento"}</h2>
                
                <form onSubmit={handleSubmit} style={styles.form}>
                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Nome (es. Bpm, Unicredit, Contanti, PayPal....)</label>
                        <input 
                            type="text" 
                            value={nome} 
                            onChange={(e) => setNome(e.target.value)} 
                            style={styles.input} 
                            required 
                        />
                    </div>

                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Conto (opzionale)</label>
                        <input 
                            type="text" 
                            value={conto} 
                            onChange={(e) => setConto(e.target.value)} 
                            style={styles.input} 
                        />
                    </div>

                    <div style={styles.modalButtons}>
                        <button type="submit" style={styles.saveBtn}>Salva</button>
                        
                        {metodoDaModificare && (
                            <button 
                                type="button" 
                                onClick={() => props.onDelete(metodoDaModificare.id)} 
                                style={styles.deleteBtn}
                            >
                                Elimina
                            </button>
                        )}
                        
                        <button type="button" onClick={props.onClose} style={styles.cancelBtn}>Chiudi</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

const styles = {
    modalOverlay: {
        position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.75)', backdropFilter: 'blur(4px)',
        display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000,
    },
    modalContent: {
        backgroundColor: '#1e293b', padding: '30px', borderRadius: '16px',
        width: '100%', maxWidth: '400px', color: '#ffffff', border: '1px solid #334155',
        boxShadow: '0 25px 30px -10px rgba(0,0,0,0.6)', textAlign: 'center',
    },
    form: { display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '20px' },
    inputGroup: { display: 'flex', flexDirection: 'column', textAlign: 'left' },
    label: { fontSize: '0.85rem', marginBottom: '6px', color: '#cbd5e1' },
    input: { padding: '12px', borderRadius: '8px', border: '1px solid #475569', backgroundColor: '#0f172a', color: '#ffffff', fontSize: '1rem', outline: 'none' },
    modalButtons: { display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '15px' },
    saveBtn: { backgroundColor: '#22c55e', color: '#0f172a', border: 'none', padding: '11px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' },
    deleteBtn: { backgroundColor: '#ef4444', color: '#ffffff', border: 'none', padding: '11px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' },
    cancelBtn: { backgroundColor: 'transparent', color: '#cbd5e1', border: '1px solid #475569', padding: '11px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }
};

export default PaymentMethodModal;
